// Theme Definitions
export const MONACO_THEMES = {
  editMode: {
    name: 'edit-mode',
    definition: {
      base: 'vs' as const,
      inherit: true,
      rules: [
        { token: '', foreground: '000000' },
        { token: 'comment', foreground: '888888' },
        { token: 'string.key.json', foreground: '0451a5' },
        { token: 'string.value.json', foreground: '0451a5' },
        { token: 'number.json', foreground: '098658' },
        { token: 'keyword.json', foreground: 'af00db' },
      ],
      colors: {
        'editor.background': '#ffffff',
        'editor.foreground': '#000000',
        'editor.lineHighlightBackground': '#e3f2fd',
        'editorCursor.foreground': '#1976d2',
        'editor.selectionBackground': '#bbdefb',
        'editorLineNumber.foreground': '#1976d2',
        'editorBracketMatch.background': '#ffd54f',
        'editorBracketMatch.border': '#ff9800',
      },
    },
  },
  readonlyMode: {
    name: 'readonly-mode',
    definition: {
      base: 'vs' as const,
      inherit: true,
      rules: [
        { token: '', foreground: '444444' },
        { token: 'comment', foreground: '999999' },
        { token: 'string.key.json', foreground: '616161' },
        { token: 'string.value.json', foreground: '616161' },
        { token: 'number.json', foreground: '757575' },
        { token: 'keyword.json', foreground: '9e9e9e' },
      ],
      colors: {
        'editor.background': '#fcfafa',
        'editor.foreground': '#444444',
        'editorCursor.foreground': '#999999',
        'editorLineNumber.foreground': '#cccccc',
        'editorBracketMatch.background': '#e0e0e0',
        'editorBracketMatch.border': '#bdbdbd',
      },
    },
  },
}

// Editor Options Configuration
export const EDITOR_OPTIONS = {
  base: {
    links: false,
    minimap: { enabled: false },
    scrollBeyondLastLine: false,
    fontSize: 13,
    lineHeight: 1.7,
    fontFamily: '"Roboto Mono", "Consolas", "Monaco", monospace',
    wordWrap: 'on' as const,
    automaticLayout: true,
    bracketPairColorization: { enabled: true },
    guides: {
      bracketPairs: true,
      indentation: true,
    },
  },
  editMode: {
    cursorBlinking: 'blink' as const,
    cursorStyle: 'line' as const,
    cursorWidth: 2,
    renderLineHighlight: 'all' as const,
    selectionHighlight: true,
    occurrencesHighlight: 'multiFile' as const,
    scrollbar: {
      vertical: 'auto' as const,
      horizontal: 'auto' as const,
    },
  },
  readonlyMode: {
    cursorBlinking: 'solid' as const,
    cursorStyle: 'line-thin' as const,
    cursorWidth: 1,
    renderLineHighlight: 'none' as const,
    selectionHighlight: false,
    occurrencesHighlight: 'off' as const,
    scrollbar: {
      vertical: 'auto' as const,
      horizontal: 'auto' as const,
    },
  },
}
